function PanFrontViewRTDR(vars) {
  const getAngle = (p5, v1, v2) => +(Math.abs(degrees(Math.atan(
      (v1.y - v2.y) / (v1.x - v2.x),
  ))).toFixed(1));
  const { p5, backgroundPattern, state: {
    scale,
  } } = this;

  const {
    panWidth, panHeight, splashWallWidth,
    drainWidth, drainX, trenchFloorThickness,
    drainPlateWidth, depthDeclineTotal,
    drainPosition, grateThickness, drainDimensionWidth,
    curbWidth, curbHeight,
  } = vars;

  const { drainOpening } = panBaseSpec;
  const { toleranceRange } = specText;

  const {
    cornerLineLength, panLineMargin, sectionDimensionClearance,
  } = specConfig;

  const vLine = cornerLineLength / 4;
  const sectionDimensionOffset = panLineMargin + vLine + sectionDimensionClearance;
  const margin = 100;
  const padding = 10;
  const panFront = createGraphics(panWidth + margin, panHeight + margin);

  panFront.translate(padding, padding);
  panFront.fill(255);
  panFront.drawingContext.fillStyle = backgroundPattern;

  // Splash Wall Meet Floor
  const leftWallMeetsFloor = createVector(
    splashWallWidth,
    panHeight - trenchFloorThickness - depthDeclineTotal,
  );

  // Floor meet drain left
  const floorMeetsDrainLeft = createVector(
    drainX - (drainPlateWidth / 2),
    panHeight - trenchFloorThickness,
  );


  // Floor meets drain right
  const floorMeetsDrainRight = createVector(
    drainX + (drainPlateWidth / 2),
    panHeight - trenchFloorThickness,
  );

  // Floor meets right wall
  const floorMeetsRightWall = createVector(
    panWidth - curbWidth,
    panHeight - trenchFloorThickness - depthDeclineTotal,
  );

  const rightFloorAngle = getAngle(
    p5, floorMeetsDrainRight, floorMeetsRightWall,
  );

  const leftFloorAngle = getAngle(
    p5, leftWallMeetsFloor, floorMeetsDrainLeft,
  );

  let leftWallAdjust = 0;
  let rightWallAdjust = 0;

  const angleDelta = Math.abs(leftFloorAngle - rightFloorAngle);
  let adjustmentPercentage = +((angleDelta / 10).toFixed(2));
  if (adjustmentPercentage > 1) adjustmentPercentage = 1;


  if (angleDelta > 2) {
    if (leftFloorAngle > rightFloorAngle) {
      leftWallAdjust = Math.ceil((floorMeetsDrainLeft.y - leftWallMeetsFloor.y) * adjustmentPercentage);
    } else {
      rightWallAdjust = Math.ceil((floorMeetsDrainRight.y - floorMeetsRightWall.y) * adjustmentPercentage);
    }
  }

  panFront.beginShape();
  panFront.vertex(0, 0);
  panFront.vertex(splashWallWidth, 0);

  const grateWidthInches = this._getTrenchSize(this.state.panWidthInches - this.state.splashWallWidthInches - this.state.curbWidthInches);
  const floorOutsideTrench = panWidth - splashWallWidth - curbWidth - Math.round(grateWidthInches * scale);


  panFront.vertex(leftWallMeetsFloor.x, leftWallMeetsFloor.y + leftWallAdjust);

  if (drainPosition === 'Back') {
    panFront.vertex(leftWallMeetsFloor.x, leftWallMeetsFloor.y + depthDeclineTotal);
    panFront.vertex(leftWallMeetsFloor.x + floorOutsideTrench / 2, leftWallMeetsFloor.y + depthDeclineTotal);
    panFront.vertex(leftWallMeetsFloor.x + floorOutsideTrench / 2, floorMeetsDrainLeft.y + grateThickness);
    panFront.vertex(floorMeetsDrainLeft.x, floorMeetsDrainLeft.y + grateThickness);
  } else {
    panFront.vertex(leftWallMeetsFloor.x, leftWallMeetsFloor.y + leftWallAdjust);
    panFront.vertex(floorMeetsDrainLeft.x, leftWallMeetsFloor.y + depthDeclineTotal);
    panFront.vertex(floorMeetsDrainLeft.x, floorMeetsDrainLeft.y + grateThickness);
  }


  if (drainPosition === 'Back') {
    panFront.vertex(floorMeetsRightWall.x - floorOutsideTrench / 2, floorMeetsDrainRight.y + grateThickness);
    panFront.vertex(floorMeetsRightWall.x - floorOutsideTrench / 2, floorMeetsRightWall.y + depthDeclineTotal);
    panFront.vertex(floorMeetsRightWall.x, floorMeetsRightWall.y + depthDeclineTotal);
    panFront.vertex(floorMeetsRightWall.x, panHeight - curbHeight);
  } else {
    panFront.vertex(floorMeetsDrainRight.x, floorMeetsDrainRight.y + grateThickness);
    panFront.vertex(floorMeetsDrainRight.x, floorMeetsRightWall.y + depthDeclineTotal);
    panFront.vertex(floorMeetsRightWall.x, floorMeetsRightWall.y + rightWallAdjust);
    panFront.vertex(floorMeetsRightWall.x, panHeight - curbHeight);
  }


  panFront.vertex(panWidth, panHeight - curbHeight);
  panFront.vertex(panWidth, panHeight);
  panFront.vertex(0, panHeight);
  panFront.vertex(0, 0);
  panFront.endShape();

  this._cutCompressionDrainPocket(panFront, {
    axis: 'front',
    center: drainX,
    surface: floorMeetsDrainLeft.y + grateThickness,
    bottom: panHeight,
    depth: vars.drainHeight,
    panVariant: 'trench',
    trenchSection: drainPosition === 'Back' ? 'along' : 'cross',
  });

  textSize(14);

  // Pan Width
  this._createMeasureLine(
    splashWallWidth, -(panLineMargin + vLine - 5),
    panWidth - curbWidth, -(panLineMargin + vLine - 5),
    this.state.panWidthInches - this.state.curbWidthInches - this.state.splashWallWidthInches,
  );

  // Drain Width
  this._createMeasureLine(
    drainX - (drainDimensionWidth / 2) - 1, panHeight + vLine + 5,
    drainX + (drainDimensionWidth / 2) + 1, panHeight + vLine + 5,
  );

  // Curb Width
  this._createMeasureLine(
    panWidth - curbWidth,
    -(panLineMargin + vLine - 5),
    panWidth,
    -(panLineMargin + vLine - 5),
  );

   // Curb Height
  this._createMeasureLine(
    panWidth + panLineMargin + vLine - 5,
    panHeight - curbHeight,
    panWidth + panLineMargin + vLine - 5,
    panHeight,
    this.state.curbHeightInches,
  );

  // Splash Wall Height
  this._createMeasureLine(
    -(sectionDimensionOffset - 5), 0,
    -(sectionDimensionOffset - 5), panHeight,
    panBaseSpec.height,
  );

  // Left Splash Wall Width
  this._createArrow(
    -5,
    -(panLineMargin + vLine - 5),
    'right',
    5,
  );

  // Right Splash Wall Width
  stroke('black');
  strokeWeight(1);
  line(
    panWidth,
    -(panLineMargin + vLine - 5),
    panWidth + 12,
    -(panLineMargin + vLine - 5),
  );

  // Splash wall width
  this._createText(
    this.state.splashWallWidthInches,
    -28, -(panLineMargin + vLine - 10),
  );

  // Curb Width
  this._createText(
    this.state.curbWidthInches,
    panWidth + 30, -(panLineMargin + vLine - 10),
  );

  textSize(12);
  text(
    toleranceRange,
    panWidth + 10, -(panLineMargin + vLine -25),
  );

  image(panFront, -(padding), -(padding));

  const drainGraphic = this._createTrenchDrain({
    ...vars, vLine,
  });

  image(
    drainGraphic,
    (drainX - (drainWidth / 2) - 10),
    (panHeight - trenchFloorThickness + grateThickness) - 13,
  );

  this._createText(
    drainOpening,
    drainX + drainWidth + 12,
    panHeight + vLine + 10,
  );

  stroke('black');
  strokeWeight(1);

  // Drain Width Pointer
  line(
    drainX + (drainDimensionWidth / 2) - 1, panHeight + vLine + 5,
    drainX + (drainDimensionWidth / 2) + 10, panHeight + vLine + 5,
  );

  // Splash Wall Width - LEFT
  line(0, -(panLineMargin), 0, -(panLineMargin + vLine));
  line(splashWallWidth, -(panLineMargin), splashWallWidth, -(panLineMargin + vLine));

  // Right Curb
  line(panWidth - curbWidth, -(panLineMargin), panWidth - curbWidth, -(panLineMargin + vLine));
  line(panWidth, -(panLineMargin), panWidth, -(panLineMargin + vLine));

  // Pan Height
  line(
    -(panLineMargin), 0,
    -sectionDimensionOffset, 0,
  );

  line(
    -(panLineMargin), panHeight,
    -sectionDimensionOffset, panHeight,
  );

  // Curb Height
  line(
    panWidth + panLineMargin + vLine, panHeight - curbHeight,
    panWidth + panLineMargin, panHeight - curbHeight
  );

  line(
    panWidth + panLineMargin + vLine, panHeight,
    panWidth + panLineMargin, panHeight
  );

  // Back Splash Wall Line
  line(
    0, 0,
    panWidth, 0,
  );

  line(
    panWidth, 0,
    panWidth, panHeight - curbHeight,
  );

  // Trench Grate Line
  if (drainPosition === 'Back') {
    line(
      splashWallWidth, panHeight - trenchFloorThickness,
      panWidth - curbWidth, panHeight - trenchFloorThickness,
    );
  } else {
    line(
      floorMeetsDrainLeft.x, panHeight - trenchFloorThickness,
      floorMeetsDrainRight.x, panHeight - trenchFloorThickness,
    );
  }

  noStroke();
  textSize(20);

  text(
    'SECTION A-A',
    (panWidth / 2) - (this._getTextWidth('SECTION A-A') / 2),
    120,
  );
}
